import React from 'react';

export default ({ color = '#8E95AA', size = 19 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.95866 2.69141C4.14059 2.69141 4.32075 2.72724 4.48883 2.79686C4.65692 2.86649 4.80965 2.96854 4.9383 3.09719C5.06694 3.22583 5.16899 3.37856 5.23862 3.54665C5.30824 3.71473 5.34408 3.89489 5.34408 4.07682C5.34408 4.25876 5.30824 4.43891 5.23862 4.607C5.16899 4.77509 5.06694 4.92781 4.9383 5.05646C4.80965 5.18511 4.65692 5.28716 4.48883 5.35678C4.32075 5.4264 4.14059 5.46224 3.95866 5.46224C3.59122 5.46224 3.23884 5.31628 2.97902 5.05646C2.71921 4.79664 2.57324 4.44426 2.57324 4.07682C2.57324 3.70939 2.71921 3.357 2.97902 3.09719C3.23884 2.83737 3.59122 2.69141 3.95866 2.69141ZM2.69199 6.64974H5.22533V16.3081H2.69199V6.64974ZM7.12533 6.64974H9.55574V7.97182H9.58741C9.8304 7.55521 10.1818 7.21227 10.6042 6.97946C11.0266 6.74666 11.5042 6.63271 11.9862 6.64974C14.5591 6.64974 15.042 8.34391 15.042 10.5447V15.5164H12.5087V11.1068C12.5087 10.0539 12.4928 8.70016 11.0441 8.70016C9.57158 8.70016 9.34991 9.84807 9.34991 11.0356V15.5164H7.12533V6.64974Z"
      fill={color}
    />
  </svg>
);
